/**
 * ユーザー関連のStoreで使用するStateをここで定義する
 *
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Record } from 'immutable'

const _StripeKeyState = {
  id: null,
  hotel_id: '',
  hotel_name: '',
  api_key: '',
  test: false
}

class StripeKeyState extends Record(_StripeKeyState) {
  mergeModel(model) {
    return this.merge(model)
  }
}

export { StripeKeyState }
